export interface EnvironmentConfiguration {
  name: string;
  isTest: boolean;
  otpSenderForAll?: 'Email' | 'Sms';
  logLevel?: 'Verbose' | 'Debug' | 'Information' | 'Warning' | 'Error' | 'Fatal';
  logAll: boolean;
}

export class AppConfig {
  baseUrl: string = undefined as any;
  authority: string = undefined as any;
  clientId: string = undefined as any;
  clientSecret: string = undefined as any;
  postLogoutRedirectUri: string = undefined as any;
  redirectUri: string = undefined as any;
  envConfig: EnvironmentConfiguration = {
    name: 'production',
    isTest: false,
    logLevel: undefined,
    otpSenderForAll: undefined,
    logAll: false
  };
}

export const config: AppConfig = {
  baseUrl: window.REACT_APP_API_BASE_URI as string,
  authority: window.REACT_APP_OIDC_AUTHORITY as string,
  clientId: window.REACT_APP_OIDC_CLIENT_ID as string,
  clientSecret: window.REACT_APP_OIDC_CLIENT_SECRET as string,
  postLogoutRedirectUri: window.REACT_APP_OIDC_REDIRECT_URI as string,
  redirectUri: window.REACT_APP_OIDC_REDIRECT_URI as string,
  envConfig: {
    isTest: (window.REACT_APP_ENV__IS_TEST as string).toLowerCase() === 'true',
    name: window.REACT_APP_ENV as string,
    logLevel: window.REACT_APP_ENV__LOG_LEVEL as 'Verbose' | 'Debug' | 'Information' | 'Warning' | 'Error' | 'Fatal',
    otpSenderForAll: window.REACT_APP_ENV__OTP_SENDER_FOR_ALL as 'Email' | 'Sms',
    logAll: (window.REACT_APP_ENV__LOG_ALL as string).toLowerCase() === 'true'
  }
};

export default config;
